import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Trophy, Medal } from "lucide-react";

const RANK = [
  "bg-amber-100 text-amber-600 border-amber-300",
  "bg-slate-100 text-slate-500 border-slate-300",
  "bg-orange-100 text-orange-600 border-orange-300",
];

export function TopAttendance() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/top-attendance", { params: { limit: 5 } }).then((r) => setData(r.data)); }, []);

  return (
    <Card className="p-6 rounded-2xl border-amber-100" data-testid="top-attendance-card">
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-5 h-5 text-amber-500" />
        <h3 className="font-display text-xl font-bold text-slate-900">Siswa Paling Rajin</h3>
      </div>
      {!data || data.rows.length === 0 ? (
        <p className="text-sm text-slate-400 py-6 text-center">Belum ada data absensi bulan ini ✏️</p>
      ) : (
        <div className="space-y-2">
          {data.rows.map((r, i) => (
            <div key={r.id} data-testid={`top-attendance-${i}`} className="flex items-center gap-3 p-3 rounded-xl bg-amber-50/70">
              <div className={`w-9 h-9 rounded-full border-2 flex items-center justify-center font-display font-bold ${RANK[i] || "bg-white text-slate-400 border-slate-200"}`}>
                {i < 3 ? <Medal className="w-4 h-4" /> : i + 1}
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-slate-800 truncate">{r.name}</div>
                <div className="text-xs text-slate-400">{r.level} · {r.hadir}/{r.total_sesi} sesi hadir</div>
              </div>
              <div className="font-display font-bold text-emerald-600 text-lg">{r.pct}%</div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
